import TimesheetLinesForm from '../../../../components/People/Timesheet/Lines/TimesheetLinesForm'
import React from 'react'
import {Modal} from 'antd'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'

function TimesheetLinesModal(props) {
  const {
    remove,
    submit,
    update,
    visible,
    modalType,
    formRef,
    onCancel,
    removing,
    submitting,
  } = props
  const isNew = modalType === 'new'
  return (
    <Modal
      visible={visible}
      title={'Day timesheet'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          submit={submit}
          remove={remove}
          update={update}
          removing={removing}
          submitting={submitting}
          title={'Days'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <TimesheetLinesForm ref={formRef} {...props} />
    </Modal>
  )
}

TimesheetLinesModal.propTypes = {}
TimesheetLinesModal.defaultProps = {}

export default TimesheetLinesModal
